import { render } from "./message-tool.vue?vue&type=template&id=64626199&scoped=true&ts=true"
import script from "./message-tool.vue?vue&type=script&lang=ts"
export * from "./message-tool.vue?vue&type=script&lang=ts"

import "./message-tool.vue?vue&type=style&index=0&id=64626199&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64626199"]])

export default __exports__